// Shared helpers for Search Bars (Desktop/Mobile)

export const pad2 = (n) => String(n).padStart(2, '0');

export const toISO = (date) => {
    if (!date) return '';
    const d = date.getDate();
    const m = date.getMonth() + 1;
    const y = date.getFullYear();
    return `${y}-${pad2(m)}-${pad2(d)}`;
};

export const formatDateBr = (isoDate) => {
    if (!isoDate || typeof isoDate !== 'string') return '';
    const m = isoDate.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return '';
    const [, y, mo, d] = m;
    return `${d}/${mo}/${y}`;
};

export const formatDateBrFromDate = (date) => {
    if (!date) return '';
    const d = date.getDate();
    const m = date.getMonth() + 1;
    const y = date.getFullYear();
    return `${pad2(d)}/${pad2(m)}/${y}`;
};

export const parseDateBrToDate = (br) => {
    if (!br || typeof br !== 'string') return null;
    const m = br.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!m) return null;
    const d = parseInt(m[1], 10);
    const mo = parseInt(m[2], 10) - 1;
    const y = parseInt(m[3], 10);
    const dt = new Date(y, mo, d);
    if (dt.getFullYear() !== y || dt.getMonth() !== mo || dt.getDate() !== d) return null;
    return dt;
};

export const parseSearchFromPath = () => {
    const path = window.location.pathname || '';
    const idx = path.indexOf('/pesquisa/');
    if (idx === -1) return { destinationSlug: '', beginDate: '', endDate: '' };

    const sub = path.substring(idx);
    const match = sub.match(/\/pesquisa\/([^/]+)\/(\d{4}-\d{2}-\d{2})\/(\d{4}-\d{2}-\d{2})\/?/);

    if (!match) return { destinationSlug: '', beginDate: '', endDate: '' };

    const [, destinationSlug, beginDate, endDate] = match;
    return { destinationSlug, beginDate, endDate };
};



// WEBPACK FOOTER //
// ./src/views/v2/search/utils/searchParsing.js